export default "/_next/static/edfd2131de6f7ab582978aabc7f30805.png";